var map = {
	"./2672860-200.png": 7413,
	"./3.png": 1880,
	"./Design sans titre (3).png": 8436,
	"./Group-Photo.png": 4053,
	"./Step-01.png": 5061,
	"./Step-02.png": 2638,
	"./Step-03.png": 8660,
	"./anchor.png": 6008,
	"./cruise.png": 9234,
	"./icon.png": 6328,
	"./logo_bookmymarina.png": 7720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;